import * as d3 from "d3";
function createScales(beginning, now, yMin, yMax, innerWidth, innerHeight, logarithmic = false) {
    let xScale, yScale;
    if (logarithmic) {
        const validYMin = Math.max(yMin, 1);
        xScale = d3.scaleTime().domain([
            beginning,
            now
        ]).range([
            0,
            innerWidth
        ]);
        yScale = d3.scaleLog().domain([
            validYMin,
            yMax
        ]).range([
            innerHeight,
            0
        ]);
    } else {
        xScale = d3.scaleTime().domain([
            beginning,
            now
        ]).range([
            0,
            innerWidth
        ]);
        yScale = d3.scaleLinear().domain([
            yMin,
            yMax
        ]).range([
            innerHeight,
            0
        ]);
    }
    return {
        xScale,
        yScale
    };
}
// helper function for determining tick values for log-scaled graphs
function isPowerOfTen(num) {
    if (num <= 0) {
        return false;
    }
    while(num > 1){
        if (num % 10 !== 0) {
            return false;
        }
        num /= 10;
    }
    return true;
}
export { createScales, isPowerOfTen };
